import React, { Component } from 'react'
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs'
import MainLayout from '../CommonControlls/MainLayout'
import Topmenu from '../CommonControlls/Topmenubar'
import { connect } from 'react-redux'
import AlertModal from '../CommonControlls/AlertModal'
import Table from '../CommonControlls/TableRendrer'
import { Link } from 'react-router-dom'

const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({ type: 'UpdateAlert', payload: Settings })
        },
        ShowLoader: (Isloading) => {
            dispatch({ type: 'UpdateLoader', payload: Isloading })
        },
    }
}

class Roles_List extends Component {
    constructor(props) {
        super(props)
        this.state = {
            Save: true,
            Update: true,
            Delete: true,
            View: true,

            alertModalData: {
                title: '',
                message: '',
                First_Callback: () => { },
                Second_Callback: () => { },
                type: 1,
            },

            // Table
            data: [],
            page: 1,
            sizePerPage: 15,
            TotalRecord: 0,
            loading: false,
        }
    }

    render() {
        const CellMenu = (cell, row) => {
            return (
                <div>
                    <Link to={'/Roles_Edit/' + row.id}>
                        <button data-toggle="tooltip" title="Edit" class="btn TableRow_btn">
                            <i class="fa fa-pencil-square-o text-primary" aria-hidden="true"></i>
                        </button>
                    </Link>
                    <button
                        data-toggle="tooltip"
                        title="Delete"
                        onClick={() => this.onDelete(row.id)}
                        class="btn TableRow_btn"
                    >
                        <i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
                    </button>
                </div>
            )
        }

        const columns = [
            {
                dataField: 'id',
                text: 'ID',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { minWidth: 80 }
                },
            },
            {
                dataField: 'roleName',
                text: 'Name',
                headerStyle: (colum, colIndex) => {
                    return { minWidth: 120 }
                },
                sort: true,
            },

            {
                dataField: 'createdDate',
                text: 'Created On',
                headerStyle: (colum, colIndex) => {
                    return { minWidth: 120 }
                },
                sort: true,
            },
            {
                dataField: '',
                text: 'Actions',
                headerStyle: (colum, colIndex) => {
                    return { minWidth: 120 }
                },
                formatter: (cell, row) => {
                    return CellMenu(cell, row)
                },
                csvExport: false,
            },
        ]

        return (
            <div>
                <MainLayout />
                <AlertModal {...this.state.alertModalData} />
                <div id="right-panel" class="right-panel">
                    {/* <Topmenu/>               */}
                    <Topmenu
                        PageTitle="Roles & Permissions"
                        isShowAddBtn={true}
                        AddBtnLabel="Add Role"
                        AddBtnLink="/Roles_Add"
                    />

                    <div class="content">
                        <div class="PageHeader_Container">
                            <h2 class="Pageheading">Roles</h2>
                        </div>

                        <div class="card">
                            <div class="card-body">
                                {/* <div class="TableTop_Buttons">
                        <span class="TableExport_button"><i class="fa fa-download" aria-hidden="true"></i> Export</span>
                    </div> */}

                                <Table
                                    keyField="id"
                                    data={this.state.data}
                                    page={this.state.page}
                                    sizePerPage={this.state.sizePerPage}
                                    totalSize={this.state.TotalRecord}
                                    onTableChange={this.handleTableChange}
                                    isPagination={true}
                                    columns={columns}
                                    loading={this.state.loading}
                                    RefreshTable={this.PopulateTable}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === '') {
            this.props.history.push('/Login')
        }
        // else
        // {
        //     if(this.props.UserAuthentication.UserInfo?.permissions == "All")
        //     {
        //       this.setState({
        //         Save: false,
        //         Update:false,
        //         Delete:false,
        //         View:false
        //       })
        //     }
        //     else
        //     {
        //       Common.GetUserPermissions(this.props.UserAuthentication.UserInfo?.permissions,"Roles",(lst)=>{
        //         if ( lst.indexOf("View") == -1 )
        //         {
        //             this.props.history.push("/Dashboard")
        //         }
        //         else
        //         {
        //           for(var i = 0; i < lst.length; i++)
        //           {
        //             this.setState({
        //                 [lst[i]]: false
        //             })
        //           }
        //         }
        //       })
        //     }
        // }
    }

    componentDidMount() {
        //if (this.props.UserAuthentication.AuthToken === '') {
        //    this.props.history.push('/Login')
        //}

        Common.AddClassToMenueLink(
            'MenuLink_Roles',
            true,
            'MenuParentLink_Security',
        )
        this.PopulateTable()
    }

    handleTableChange = (
        type,
        { page, sizePerPage, filters, sortField, sortOrder, cellEdit },
    ) => {
        if (type === 'sort') {
            let result = this.state.data
            // Handle column sort
            if (sortOrder === 'asc') {
                result = result.sort((a, b) => {
                    if (a[sortField] > b[sortField]) {
                        return 1
                    } else if (b[sortField] > a[sortField]) {
                        return -1
                    }
                    return 0
                })
            } else {
                result = result.sort((a, b) => {
                    if (a[sortField] > b[sortField]) {
                        return -1
                    } else if (b[sortField] > a[sortField]) {
                        return 1
                    }
                    return 0
                })
            }
            return
        }
        this.setState(
            {
                page,
                sizePerPage,
            },
            () => {
                this.PopulateTable()
            },
        )
    }

    PopulateTable = () => {
        this.setState({ loading: true })

        var Parameters = {
            pageSize: this.state.sizePerPage,
            pageNumber: this.state.page,
        }

        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            'Get',
            false,
            Common.APILinks.SelectAll_Role,
            Parameters,
            (resp) => {
                this.setState({ loading: false })
                if (resp.status) {
                    this.setState({
                        data: resp.data.reverse(),
                        TotalRecord: resp.data.length,
                    })
                } else {
                    this.props.ShowAlert({ Type: 0, Msg: resp.message })
                    setTimeout(function () {
                        $('#Alertmsgbtn').click()
                    }, 50)
                }
            },
            (error) => {
                $('#FormSearchBtn').prop('disabled', false)
                this.setState({ loading: false })
                this.props.ShowAlert({
                    Type: 0,
                    Msg: 'Something went wrong, please try again.',
                })
                setTimeout(function () {
                    $('#Alertmsgbtn').click()
                }, 50)
            },
        )
    }

    onDelete = (id) => {
        this.setState(
            {
                alertModalData: {
                    title: 'Delete Role',
                    message: 'Are you sure you want to delete this record.',
                    First_Callback: () => {
                        $('#Generic-modal-CloseBtn').click()
                        this.DeleteRecord(id)
                    },
                    Second_Callback: () => {
                        $('#Generic-modal-CloseBtn').click()
                    },
                    type: 1,
                },
            },
            () => {
                $('#Show_ArletModal').click()
            },
        )
    }

    DeleteRecord = (id) => {
        this.props.ShowLoader({ Isloading: true })
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            'POST',
            false,
            Common.BaseUrlAPI + `/api/roles/DeleteRole?role_id=${id}`,
            {},
            (Result) => {
                this.props.ShowLoader({ Isloading: false })
                if (Result.status) {
                    this.PopulateTable()
                    this.props.ShowAlert({ Type: 1, Msg: 'Deleted Successfully' })
                    setTimeout(function () {
                        $('#Alertmsgbtn').click()
                    }, 50)
                } else {
                    this.props.ShowLoader({ Isloading: false })
                    this.props.ShowAlert({ Type: 0, Msg: Result.message })
                    setTimeout(function () {
                        $('#Alertmsgbtn').click()
                    }, 50)
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({
                    Type: 0,
                    Msg: 'Something went wronge, please try again.',
                })
                setTimeout(function () {
                    $('#Alertmsgbtn').click()
                }, 50)
            },
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Roles_List)
